var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlikeHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2447 1.22217C11.4298 1.23825 10.6385 1.49433 9.97294 1.95734C9.30738 2.42036 8.79811 3.06906 8.51085 3.81972C8.22166 3.0627 7.71016 2.40746 7.04144 1.93738C6.37271 1.4673 5.577 1.20363 4.75555 1.17993C4.2608 1.17427 3.7699 1.266 3.31168 1.44972C2.85347 1.63344 2.4372 1.90545 2.08733 2.24976C1.73747 2.59407 1.46107 3.00374 1.27439 3.45468C1.0877 3.90562 0.994498 4.38874 1.00025 4.87564C1.00025 9.60614 8.51085 14.8857 8.51085 14.8857C8.51085 14.8857 16 9.60614 16 4.87564C16 4.39228 15.9026 3.91373 15.7134 3.46769C15.5241 3.02166 15.2468 2.61701 14.8975 2.2772C14.5483 1.93739 14.1339 1.66916 13.6785 1.48806C13.2232 1.30696 12.7358 1.21658 12.2447 1.22217V1.22217Z",
    stroke: "url(#paint0_linear_2502_1036)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2502_1036",
    x1: 8.5,
    y1: 1.17969,
    x2: 8.5,
    y2: 14.8857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlikeHeart);
export default __webpack_public_path__ + "static/media/unlike-heart.f085b6ee9350703286dced021de9b87d.svg";
export { ForwardRef as ReactComponent };